// --- Core ---
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
// --- SaniQ ---
import {OnlineStatus} from "../../../models/physician/OnlineStatus";
import {contains, pluck} from "underscore";

interface OnlineStatusState {
  onlineStatuses: OnlineStatus[];
}

const initialState: OnlineStatusState = {
  onlineStatuses: []
};


const onlineStatusSlice = createSlice({
  // eslint-disable-next-line formatjs/no-literal-string-in-object
  name: 'onlineStatus',
  initialState,
  reducers: {
    updateOnlineStatus(state, action: PayloadAction<OnlineStatus>) {
      const physicianIds = pluck(state.onlineStatuses, 'id');

      if(contains(physicianIds, action.payload.id)) {
        if(action.payload.onlineStatus === "offline")
          state.onlineStatuses = state.onlineStatuses.filter(
            (status: OnlineStatus) => status.id !== action.payload.id
          );
      } else {
        state.onlineStatuses = state.onlineStatuses.concat(action.payload);
      }
    }
  }
});

export const {updateOnlineStatus} = onlineStatusSlice.actions;

export default onlineStatusSlice.reducer;
